<div class="px-4">
  <h1 class="textTabsColor mb-4 text-2xl font-bold" i18n="@@userOrdersTitle">Orders</h1>

  <div class="px-4">
    <app-filters [filters]="filters()" (resetFilters)="resetFilters()" (applyFilters)="applyFilters($event)" />

    @if (state() === "loading") {
      <app-loading />
    }

    @if (state() === "success") {
      <app-orders-cards-list
        [orders]="orders()"
        [isFiltersApplied]="isFiltersApplied()"
        (rowClick)="navigateToDetails($event)" />

      <app-pagination
        [itemsPerPage]="itemsPerPage()"
        [currentPage]="currentPage()"
        [totalPages]="totalPages"
        [totalItems]="totalItems()"
        (goToPage)="onPageChange($event)"
        (previousPage)="onPageChange(currentPage() - 1)"
        (nextPage)="onPageChange(currentPage() + 1)"
        (pageSizeChange)="onPageSizeChange()" />
    }
  </div>
</div>
